import DisplayFullName from "./DisplayName";


function App() {
  return (
    <div className="App">
      <DisplayFullName />
      
    </div>
  );
}

export default App;
